import { logger } from '@fe/core';
import { envConfig } from '../../configs/env';
import { getAuthInstance } from '../auth/auth-instance';

export function httpPost<T = any>(path: string, body: any | undefined = undefined): Promise<(T & { responseCode: number }) | null> {
    return callApi(path, body, 'POST');
}

export function httpPut<T = any>(path: string, body: any | undefined = undefined): Promise<(T & { responseCode: number }) | null> {
    return callApi(path, body, 'PUT');
}

export function httpDelete<T = any>(path: string, body: any | undefined = undefined): Promise<(T & { responseCode: number }) | null> {
    return callApi(path, body, 'DELETE');
}

export function httpGet<T = any>(path: string, body: any | undefined = undefined): Promise<(T & { responseCode: number }) | null> {
    return callApi(path, body, 'GET');
}

async function callApi<T = any>(
    path: string,
    body: any | undefined = undefined,
    method: 'POST' | 'PUT' | 'DELETE' | 'GET'
): Promise<(T & { responseCode: number }) | null> {
    const token = await getAuthInstance().acquireToken();
    const baseUrl = envConfig.service;
    if (path.startsWith('/')) {
        path = path.substring(1);
    }
    if (!baseUrl.includes('/api/v1')) {
        path = '/api/v1/' + path;
    }
    try {
        const response = await fetch(baseUrl + path, {
            method: method,
            body: body != undefined ? JSON.stringify(body) : undefined,
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        });

        if (!response.ok) {
            return null;
        }

        return await response.json();
    } catch (error) {
        if (error instanceof Error) {
            logger.trackException(error);
        }
        return null;
    }
}
